import { render, staticRenderFns } from "./logicManagement.vue?vue&type=template&id=44df742c&scoped=true&"
import script from "./logicManagement.vue?vue&type=script&lang=js&"
export * from "./logicManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44df742c",
  null
  
)

export default component.exports